import { jsx as _jsx } from "react/jsx-runtime";
import { CategoryTile } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { getPictureSrcset } from '../util/ImageUtil';
const CategoryTileContainer = ({ contentAlignment, cta, href, linkTitle, image, openLinkInNewTab, title, analytics, }) => {
    const { imageCdnPrefix } = useAemConfig();
    const imageSrcset = getPictureSrcset(image, imageCdnPrefix);
    return (_jsx(CategoryTile, { contentAlign: contentAlignment, href: href, linkTitle: linkTitle, dataAnalyticsBannerid: analytics === null || analytics === void 0 ? void 0 : analytics.bannerId, image: { src: `${imageCdnPrefix}${image.imagePath}`, srcset: imageSrcset, isPicture: true }, openLinkInNewTab: openLinkInNewTab, cta: cta, title: title }));
};
export default CategoryTileContainer;
